// import globals from '../../common/globals';
// import { eventBus, globalEventBus } from '../../../modules/event-bus';
import flyoutBannerMixin from '../../../components/common/vx-flyout-banner/vx-flyout-banner-mixin';

export default {
  name: 'vx-pagelinks',
  components: { },
  mixins: [flyoutBannerMixin],

  data() {
    return {
      sites: [],
      pagesArray: [],
      env: ['https://', 'https://gpa-p-adm.srv.gapac.com/'],
      sameTab: false,
      page: '',
      showMore: false,
      hasCDNPath: false,
      cdnPathVal: '',
    };
  },
  watch: {
    showMore(val) {
      if (!val) {
        const siteButtonsToRemove = ['cpg.gp.com', 'tomorrowinmind.com', 'ultrabowls.dixie.com', 'mdtissue.com'];
        for (let i = 0; i < siteButtonsToRemove.length; i++) {
          const index = this.sites.indexOf(siteButtonsToRemove[i]);
          if (index > -1) {
            this.sites.splice(index, 1);
          }
        }
        document.getElementById('staticToggle').classList.remove('selected');
      }
    },
    sites(val) {
      this.$nextTick(() => {
        if (val.length === 1 && this.sameTab) {
          document.getElementById('sameTabLi').classList.add('selected');
        }
      });
    },
  },
  mounted() {
    if (document.cookie.indexOf('shownPopBlocMsg') === -1) {
      this.showFlyout(
        'alert',
        'To open multiple tabs at a time, make sure your browser is not blocking popups on this page.',
        false,
      );
      const CookieDate = new Date();
      CookieDate.setFullYear(CookieDate.getFullYear() + 10);
      document.cookie = `shownPopBlocMsg=true;expires=${CookieDate.toUTCString()}; path=/`;
    }
  },
  methods: {

    siteButtonClick(event, site) {
      const el = event.target;
      if (!el.classList.contains('selected')) {
        el.classList.add('selected');
        if (this.sites.indexOf(site) === -1) {
          this.sites.push(site);
        }
      } else {
        el.classList.remove('selected');
        const index = this.sites.indexOf(site);
        if (index > -1) {
          this.sites.splice(index, 1);
        }
      }
    },

    envButtonClick(event, clickedEnv) {
      const el = event.target;
      const selectedEnv = document.querySelector('ul#environments-block .selected');
      if (!el.classList.contains('selected')) {
        if (selectedEnv) {
          selectedEnv.classList.remove('selected');
        }
        el.classList.add('selected');
        this.env = clickedEnv;
      }
    },

    pageButtonClick(event, clickedPage) {
      const el = event.target;
      const selectedEnv = document.querySelector('ul#pages-block .selected');
      if (!el.classList.contains('selected')) {
        if (selectedEnv) {
          selectedEnv.classList.remove('selected');
        }
        el.classList.add('selected');
        this.page = clickedPage;
      }
    },

    goButtonClicked() {
      let url = this.env;
      const customPageSelected = document.getElementById('pathTextBox').classList.contains('selected');
      const customPage = document.getElementById('pathTextBox').value;
      if (this.hasCDNPath) {
        this.cdnPathVal = document.getElementById('cdnpathTextBox').value;
        if (this.cdnPathVal[0] === '/') {
          this.cdnPathVal = this.cdnPathVal.substring(1);
        }
      }
      if ((customPage !== '' && this.page === 'custom') || customPageSelected) {
        if (customPage[0] === '#') {
          this.page = /p/ + customPage.slice(1);
        } else if (customPage[0] !== '/') {
          alert(
            "Please begin path with a '/', or a '#' followed by a SKU to visit that SKU's PDP page",
          );
          return;
        } else {
          this.page = customPage;
        }
        this.page = this.page.replace(/\s/g, '');
      }

      const oldPage = this.page;
      for (let i = 0; i < this.sites.length; i++) {
        let delim = '';
        if (this.sites[i] === 'cpg.gp.com' || this.sites[i] === 'ultrabowls.dixie.com') {
          if (!(url[0] === 'https://')) {
            delim = '-';
          }
        } else if (!(url[0] === 'https://')) {
          delim = '.';
        }
        if (this.page === '/category/' || this.page === '/category/gpfamilybrands') {
          if (this.sites[i] === 'sparkletowels.com') {
            this.page += this.sites[i].slice(0, -10);
          } else if (this.sites[i] === 'ariajourney.com') {
            this.page += this.sites[i].slice(0, -11);
          } else if (this.sites[i] === 'innoviahome.com') {
            this.page += this.sites[i].slice(0, -8);
          } else {
            this.page += this.sites[i].slice(0, -4);
          }
          if (oldPage === '/category/gpfamilybrands') {
            if (this.sites[i] === 'ariajourney.com') {
              this.page = '/category/gpfamilyofbrandsaria';
            } else if (this.sites[i] === 'quiltednorthern.com') {
              this.page = '/category/gpfamilybrandsqn';
            } else if (this.sites[i] === 'vanityfairnapkins.com') {
              this.page = '/category/gpfamilybrandsqn';
            }
          }
          this.page += oldPage === '/category/' ? 'shop' : '';
        } else if (this.page === '/save') {
          if (this.sites[i] === 'angelsoft.com' || this.sites[i] === 'quiltednorthern.com') {
            this.page += '/toilet-paper-coupons';
          } else if (
            this.sites[i] === 'brawny.com' ||
            this.sites[i] === 'sparkletowels.com'
          ) {
            this.page += '/paper-towel-coupons';
          } else if (this.sites[i] === 'dixie.com') {
            this.page += '/paper-plates-coupons';
          } else if (this.sites[i] === 'vanityfairnapkins.com') {
            this.page += '/napkins-coupons';
          } else {
            this.page = '';
          }
        }
        const cdnpathQSP = this.cdnPathVal ? `?cdnpath=${this.cdnPathVal}` : '';
        url =
        this.sites[i] === 'smartedit' || this.sites[i] === 'backoffice' || this.sites[i] === 'hac'
          ? url[1] + this.sites[i]
          : url[0] + delim + this.sites[i] + this.page + cdnpathQSP;
        if (this.sameTab && this.sites.length === 1) {
          window.location = url;
        } else {
          window.open(url, `${this.env}.${this.sites[i]}`);
        }
        url = this.env;
        this.page = oldPage;
      }
    },

    toggleOpenMethod(event, clickedOpnBtn) {
      const el = event.target;
      const selectedOpnBtn = document.querySelector(
        'ul#open-toggle-block .selected',
      );
      if (!el.classList.contains('selected')) {
        if (selectedOpnBtn) {
          selectedOpnBtn.classList.remove('selected');
        }
        el.classList.add('selected');
        this.openMethod = clickedOpnBtn;
      }
    },

    clearAll() {
      this.sites = [];
      this.pagesArray = [];
      this.env = ['https://', 'https://gpa-p-adm.srv.gapac.com/'];
      this.sameTab = false;
      this.page = '';
      this.hasCDNPath = false;
      this.cdnPathVal = '';

      const selectedLIs = document.querySelectorAll('li');
      for (let i = 0; i < selectedLIs.length; i++) {
        if (selectedLIs[i].classList.contains('selected')) { document.querySelectorAll('li')[i].classList.remove('selected'); }
      }
      document.getElementById('www').classList.add('selected');
      document.getElementById('pathTextBox').classList.remove('selected');
      document.getElementById('pathTextBox').value = '';
    },

    addMultipleSites(event, site) {
      const el = event.target;
      this.showMore = (site === 'static') ? true : this.showMore;
      const queryString = `.siteButton.${site}`;
      this.$nextTick(() => {
        const siteButtonsArray = document.querySelectorAll(queryString);

        if (!el.classList.contains('selected')) {
          el.classList.add('selected');
          for (let i = 0; i < siteButtonsArray.length; i++) {
            const thisEl = siteButtonsArray[i];
            if (this.sites.indexOf(thisEl.dataset.value) === -1) {
              this.sites.push(thisEl.dataset.value);
              document.querySelectorAll(queryString)[i].classList.add('selected');
            }
          }
        } else {
          el.classList.remove('selected');
          for (let i = 0; i < siteButtonsArray.length; i++) {
            const thisElVal = siteButtonsArray[i];
            const index = this.sites.indexOf(thisElVal.dataset.value);
            if (index > -1) {
              this.sites.splice(index, 1);
              document.querySelectorAll(queryString)[i].classList.remove('selected');
            }
          }
          this.showMore = (site === 'static') ? false : this.showMore;
        }
      });
    },

    toggleSameTab() {
      this.sameTab = !this.sameTab;
      if (this.sameTab) {
        document.getElementById('sameTabLi').classList.add('selected');
      } else {
        document.getElementById('sameTabLi').classList.remove('selected');
      }
    },

    toggleCDNPath() {
      this.hasCDNPath = true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/marketingpages/components/vx-pagelinks/vx-pagelinks.js